import { render, staticRenderFns } from "./trimHandleBottomRight.vue?vue&type=template&id=d5bf3d50&"
import script from "./trimHandleBottomRight.vue?vue&type=script&lang=ts&"
export * from "./trimHandleBottomRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports